/**
 * KYC / FATCA profile field options (API values)
 * Matches mobile constants/kycProfile.ts
 */

export const OCCUPATION_OPTIONS = [
  { value: 'Public', label: 'Public' },
  { value: 'Private', label: 'Private' },
  { value: 'Business', label: 'Business' },
  { value: 'Student', label: 'Student' },
  { value: 'Housewife', label: 'Housewife' },
  { value: 'Agriculture', label: 'Agriculture' },
  { value: 'Retired', label: 'Retired' },
  { value: 'Others', label: 'Others' }
]

export const INCOME_SLAB_OPTIONS = [
  { value: 'Below-1L', label: 'Below 1L' },
  { value: '1-5L', label: '1-5L' },
  { value: '5-10L', label: '5-10L' },
  { value: '10-25L', label: '10-25L' },
  { value: '25-1Cr', label: '25L-1Cr' },
  { value: 'Above-1Cr', label: 'Above 1Cr' }
]

export const OCCUPATION_API_VALUES =
  OCCUPATION_OPTIONS?.map((o) => o?.value)?.filter(Boolean) ?? []

export const INCOME_SLAB_API_VALUES =
  INCOME_SLAB_OPTIONS?.map((o) => o?.value)?.filter(Boolean) ?? []
